import React, { useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import moment from 'moment';
import Axiosfetch from '../Common/Axiosfetch';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../QuotationRecords/QuotationStyle.css';
import baseURL from '../Common/Config';
import { ThemeContext } from '../Common/ThemeProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import FailureAlert from '../Common/Failure';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import DataExport from '../Common/Export';
import DataTable from '../Common/DataTableList';

const LRRecords = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [LRData, setLRData] = useState([]);

    const onCriteriaChange = (e) => {
        FetchLRs(e.target.value);
    };

    const FetchLRs = (option) => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (userData !== null) {
            Axiosfetch(baseURL + "GetLorryRecieptForExportByOrgID", "POST", { Status: parseInt(option), OrgID: userData.OrganizationID }, LRDataSuccess, Failure);
        }
    };

    const LRDataSuccess = (data) => {
        setLRData(data);
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const exportToCSV = () => {

        if (LRData.length > 0) {
            const csvData = [];

            LRData.map((lr, index) => {
                return csvData.push({
                    SI: (index + 1),
                    JobID: lr.JobID + "-" + moment(lr.createdAt).format("DDMMYY"),
                    Package: lr.Packages + (lr.Description !== "" ? " (" + lr.Description + ")" : ""),
                    ActualWeight: lr.ActualWeight,
                    ChargeWeight: lr.ChargeWeight,
                    PaidBy: lr.PaidBy === 1 ? "Consignor" : (lr.PaidBy === 2 ? "Consignee" : "Transnsporter"),
                    Payment: lr.Payment === 1 ? "Paid" : (lr.Payment === 2 ? "To pay" : "To be Billed"),
                    FreightCharges: lr.FreightCharges,
                    FuelCharges: lr.FuelCharges,
                    OtherCharges: lr.OtherCharges,
                    CustomerName: lr.Survey.length > 0 ? lr.Survey[0].Name : "",
                    Origin: lr.Survey.length > 0 ? (lr.Survey[0].OriginAddress + "," + lr.Survey[0].OriginCity + "," +
                        lr.Survey[0].OriginState + "," + lr.Survey[0].OriginPincode + "," + lr.Survey[0].OriginCountry) : "",
                    Destination: lr.Survey.length > 0 ? (lr.Survey[0].DestinationAddress + "," + lr.Survey[0].DestinationCity + "," +
                        lr.Survey[0].DestinationState + "," + lr.Survey[0].DestinationPincode + "," + lr.Survey[0].DestinationCountry) : "'",
                    CGST: lr.CGST,
                    SGST: lr.SGST,
                    IGST: lr.IGST,
                    CreatedDate: moment(lr.createdAt).local().format("DD/MM/YYYY hh:mm:ss A")
                });
            });

            DataExport(csvData, "LRRecords_" + moment().format("DDMMYYYY"));
        }
        else {
            Alert.error("No Data To Export", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const columns = [
        {
            name: 'JobID',
            width: "160px",
            selector: row => { return <div>{row.JobID}</div> },
            sortable: true,
        },
        {
            name: 'Packages',
            width: "120px",
            selector: row => {
                return <div style={{ whiteSpace: "normal" }}>{row.Packages + (row.Description !== "" ? " (" + row.Description + ")" : "")}</div>
            },
            sortable: true,
        },
        {
            name: 'Actual',
            selector: row => row.ActualWeight,
            sortable: true,
        },
        {
            name: 'Charges',
            selector: row => row.ChargeWeight,
            sortable: true,
        },
        {
            name: 'PaidBy',
            selector: row => row.PaidBy === 1 ? "Consignor" : (row.PaidBy === 2 ? "Consignee" : "Transnsporter"),
            sortable: true,
        },
        {
            name: 'Payment',
            width: "120px",
            selector: row => row.Payment === 2 ? "To pay" : "To be Billed",
            sortable: true,
        },
        {
            name: 'Freight',
            selector: row => row.FreightCharges,
            sortable: true,
        },
        {
            name: 'Fuel',
            selector: row => row.FuelCharges,
            sortable: true,
        },
        {
            name: 'Others',
            selector: row => row.OtherCharges,
            sortable: true,
        },
        {
            name: 'CGST',
            selector: row => row.CGST,
            sortable: true,
        }, {
            name: 'SGST',
            selector: row => row.SGST,
            sortable: true,
        },
        {
            name: 'IGST',
            selector: row => row.IGST,
            sortable: true,
        },
        {
            name: 'Created Date',
            width: "250px",
            selector: row => moment(row.CreatedAt).local().format("DD/MM/YYYY hh:mm:ss A"),
        }
    ];

    return (
        <div>
            <Header></Header>
            <div style={{ border: "none", boxShadow: "none" }} className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                    <div className="offset-md-4 col-md-4 col-12">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>Invoice Records</h5>
                    </div>
                    <div className={`${parseInt(process.env.REACT_APP_EXPORT_REQUIRED) === 1 ? "col-md-3 col-10 align-right" : "col-md-4 col-10 align-right"}`}>
                        <div className="basic-select">
                            <select className="DropdownStyle" onChange={onCriteriaChange}>
                                <option value="0">Select Option</option>
                                <option value="1">All LR's</option>
                            </select>
                        </div>
                    </div>
                    {parseInt(process.env.REACT_APP_EXPORT_REQUIRED) === 1 && (<div className="col-md-1 col-2 align-left">
                        <span data-tip="Export LR Documents" className={`cursor font-size-15rem addIconFocus ${CurrentTheme}Color`} onClick={exportToCSV}>
                            <FontAwesomeIcon icon={faFileExcel} />
                        </span>
                    </div>)}
                </div>
                <div className="row" style={{ padding: "15px" }}>
                    <div style={{ width: "100%", textAlign: "center", border: "1px solid #ccc", borderRadius: "10px" }}>
                        <DataTable columns={columns} data={LRData} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LRRecords;